class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

function isB2BSession() {
  const body = document.body;
  if (!body) return false;
  if (body.classList.contains('b2b-active-session')) return true;

  if (window.__isB2BCustomer === true) return true;

  const customerTags = String(body.getAttribute('data-customer-tags') || '').toLowerCase();
  if (customerTags.indexOf('b2b') !== -1 || customerTags.indexOf('wholesale') !== -1) return true;

  const hasCompany = String(body.getAttribute('data-customer-has-company') || '').toLowerCase();
  return hasCompany === 'true' || hasCompany === '1';
}

function isWholesalePortalContext() {
  return !!document.querySelector('.wholesale-portal-container');
}

// B2B pre-init guard — runs before Rebuy initializes
// Extends existing isB2BSession() suppression; does not replace it.
(function() {
  if (typeof window.__b2bCheckoutNavigating === 'undefined') {
    window.__b2bCheckoutNavigating = false;
  }

  // Use existing __ptpCustomerB2b flag — do not re-evaluate B2B state
  var isB2B = window.__ptpCustomerB2b === true;
  if (!isB2B) return;

  // 1. RebuyConfig flag (pre-initialization suppression)
  //    Complements existing rebuy:smartcart.show listener — covers
  //    cases where Rebuy reads config before event listeners attach.
  if (typeof window.RebuyConfig === 'undefined' || window.RebuyConfig.smartCart !== false) {
    window.RebuyConfig = window.RebuyConfig || {};
    window.RebuyConfig.smartCart = false;
  }

  // 2. cart:open interception — not currently handled in cart.js
  //    Redirects to /cart if any component dispatches cart:open for B2B.
  document.addEventListener(
    'cart:open',
    function(e) {
      e.stopImmediatePropagation();
      window.location.href = '/cart';
    },
    true
  ); // capture phase — fires before any bubble-phase listeners

  // === Buildpath Overlay Race Condition Fix ===
  // Injected to resolve Rebuy/Buildpath/Corso AJAX event conflict.
  // Buildpath shows overlay → Rebuy intercepts response →
  // Buildpath completion event never fires → overlay freezes UI.
  // Runs only when window.__ptpCustomerB2b is true (same IIFE as above).
  (function buildpathOverlayFix() {
    function killOverlay() {
      var overlay = document.getElementById('buildpath__overlay');
      if (overlay) {
        overlay.style.display = 'none';
        overlay.style.pointerEvents = 'none';
      }
    }

    document.addEventListener('rebuy:cart.change', killOverlay);
    document.addEventListener('rebuy.cart.change', killOverlay);
    document.addEventListener('rebuy:cart:change', killOverlay);

    document.addEventListener('cart:updated', killOverlay);

    var overlayKillTimer = null;
    if (typeof window.fetch === 'function' && window.fetch && !window.fetch.__ptpB2BOverlayWrapped) {
      var originalFetch = window.fetch;
      var wrappedFetch = function () {
        var fetchArgs = arguments;
        return originalFetch.apply(this, fetchArgs).then(function (response) {
          var url = fetchArgs[0] || '';
          if (
            typeof url === 'string' &&
            (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
          ) {
            clearTimeout(overlayKillTimer);
            overlayKillTimer = setTimeout(killOverlay, 300);
          }
          return response;
        });
      };
      wrappedFetch.__ptpB2BOverlayWrapped = true;
      window.fetch = wrappedFetch;
    }

  })();
  // === End Buildpath Overlay Race Condition Fix ===

  // === B2B Checkout Instant Redirect ===
  // Replaces previous 500ms delayed version. Navigation guard prevents double-redirect.
  if (!window.__ptpB2BCheckoutDelayBound) {
    window.__ptpB2BCheckoutDelayBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var checkoutBtn = e.target.closest(
          '[name="checkout"], ' +
            'button[data-checkout], ' +
            '.cart__checkout-button, ' +
            '[href="/checkout"]'
        );
        if (!checkoutBtn) return;
        if (window.__ptpCustomerB2b !== true) return;
        if (window.__b2bCheckoutNavigating) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        window.__b2bCheckoutNavigating = true;
        window.location.href = '/checkout';

        setTimeout(function () {
          window.__b2bCheckoutNavigating = false;
        }, 3000);
      },
      true
    );
  }
  // === End B2B Checkout Instant Redirect ===
})();

/** B2B / wholesale portal: hard navigation to cart — runs after DOM ready, uses isB2BSession() (not only __ptpCustomerB2b). */
function setupB2BCartNavHardRedirect() {
  if (window.__ptpB2BCartNavHardRedirectBound) return;
  window.__ptpB2BCartNavHardRedirectBound = true;

  function killBuildpathOverlay() {
    var overlay = document.getElementById('buildpath__overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.pointerEvents = 'none';
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      if (
        e.target.closest(
          '[data-type="add-to-cart-form"] button, ' +
            '.product-form__submit, ' +
            'button[name="add"], ' +
            '[data-add-to-cart]'
        )
      ) {
        return;
      }

      if (!isB2BSession() && !isWholesalePortalContext()) return;

      var cartTarget = e.target.closest(
        '#headerCart a, ' +
          '.header-cart-page-link, ' +
          '.cart-icon-bubble, ' +
          'a.b2b-qo__view-cart-btn, ' +
          'a.b2b-qo__sticky-btn, ' +
          'a#b2b-qo-footer-checkout'
      );
      if (!cartTarget) return;

      var href = (cartTarget.getAttribute('href') || '').trim();
      e.preventDefault();
      e.stopImmediatePropagation();
      killBuildpathOverlay();
      if (!href || href === '#' || href.indexOf('javascript:') === 0) {
        window.location.href = '/cart';
      } else {
        window.location.href = href.split('#')[0];
      }
    },
    true
  );
}

function setupB2BSilentAddToCartLock() {
  if (window.__b2bSilentAddToCartLockBound) return;
  if (window.__ptpCustomerB2b !== true && !isWholesalePortalContext()) return;
  window.__b2bSilentAddToCartLockBound = true;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!isB2BSession()) return;

      const isAddToCartForm =
        form.matches('[data-type="add-to-cart-form"]') ||
        form.matches('form[action*="/cart/add"]') ||
        form.querySelector('input[name="id"]');

      if (!isAddToCartForm) return;
      if (isWholesalePortalContext()) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return;
      }

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton && submitButton.getAttribute('data-b2b-silent-pending') === 'true') return;

      event.stopImmediatePropagation();
      event.preventDefault();

      if (submitButton) {
        submitButton.setAttribute('data-b2b-silent-pending', 'true');
        submitButton.setAttribute('aria-disabled', 'true');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      let didSilentAddSucceed = false;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.text().then((text) => ({ response, text })))
        .then(({ response, text }) => {
          const payload = String(text || '').trim();
          if (!response.ok) {
            throw new Error(`B2B silent add failed with status ${response.status}`);
          }

          if (payload.slice(0, 16).toLowerCase().indexOf('<!doctype') === 0) {
            throw new Error('[B2B Cart] Expected JSON but received HTML from cart/add.');
          }

          try {
            JSON.parse(payload);
          } catch (error) {
            throw new Error('[B2B Cart] Unable to parse cart/add response JSON.');
          }

          didSilentAddSucceed = true;
        })
        .catch((error) => {
          console.error('[B2B Cart] Silent add to cart failed:', error);
        })
        .finally(() => {
          if (submitButton) {
            submitButton.removeAttribute('data-b2b-silent-pending');
            submitButton.removeAttribute('aria-disabled');
          }
          if (didSilentAddSucceed) {
            document.dispatchEvent(new CustomEvent('b2b:cart-silent-updated'));
          }
        });
    },
    true
  );
}

function setupB2BCartDrawerSuppression() {
  if (window.__b2bCartDrawerSuppressionBound) return;
  window.__b2bCartDrawerSuppressionBound = true;

  document.addEventListener(
    'rebuy:smartcart.show',
    (event) => {
      if (!isB2BSession() && !isWholesalePortalContext()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const drawer = document.getElementById('rebuy-cart');
      if (drawer) {
        drawer.style.setProperty('display', 'none', 'important');
        drawer.setAttribute('aria-hidden', 'true');
      }

      const smartcart = event && event.detail ? event.detail.smartcart : null;
      if (smartcart && typeof smartcart.hide === 'function') {
        try {
          smartcart.hide();
        } catch (error) {
          console.error('[B2B Cart] Unable to hide Rebuy SmartCart:', error);
        }
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!isB2BSession() && !isWholesalePortalContext()) return;
      const notification = document.getElementById('cart-notification');
      if (!notification || !notification.classList.contains('active')) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('cart-notification')) return;
      notification.classList.remove('active', 'animate');
      notification.setAttribute('aria-hidden', 'true');
    },
    true
  );
}

function initB2BFeatures() {
  // Gate: only attach global listeners if Liquid confirms B2B session
  // OR if the current page is the wholesale portal template.
  // This prevents isB2BSession() false-positives from leaking
  // B2B interceptors into retail sessions.
  if (window.__ptpCustomerB2b === true || isWholesalePortalContext()) {
    setupB2BCartNavHardRedirect();
    setupB2BSilentAddToCartLock();
    setupB2BCartDrawerSuppression();
  }
  // Retail users: none of the above functions are called.
  // Rebuy SmartCart initializes normally without interference.
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initB2BFeatures);
} else {
  initB2BFeatures();
}

function updateFreeShippingProgress(root = document) {
  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  root.querySelectorAll('[data-free-shipping-progress]').forEach((node) => {
    const threshold = parseInt(node.getAttribute('data-free-shipping-threshold-cents'), 10) || 0;
    const current = parseInt(node.getAttribute('data-free-shipping-current-cents'), 10) || 0;
    const fill = node.querySelector('[data-free-shipping-fill]');
    const message = node.querySelector('[data-free-shipping-message]');

    if (!threshold || !fill || !message) return;

    const capped = Math.max(0, Math.min(current, threshold));
    const percent = Math.max(0, Math.min((capped / threshold) * 100, 100));
    const remaining = Math.max(0, threshold - current);

    fill.style.width = `${percent}%`;
    message.textContent =
      remaining > 0
        ? `${formatMoney(remaining)} away from Free Shipping`
        : 'You unlocked Free Shipping';
  });
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    updateFreeShippingProgress(document);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(line, parsedState.item_count);
        updateFreeShippingProgress(document);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        if (document.body.classList.contains('template-cart')) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'cart-items' } })
          );
        }
      })
      .catch(() => {
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading() {
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }
  }
}

customElements.define('cart-items', CartItems);
